<template>
  <div class="disable-withdrawal-box">
    <div class="disable-withdrawal-title">提现限制提醒</div>
    <p class="disable-withdrawal-content">
      {{ limitedInfo.limitedType === 1 ? '账号积分不足，无法提现，请尽快补齐积分' : `检测到你与负数积分账号：${limitedInfo.relevantLimiteAccount}具有关联，现已禁用提现功能，若有疑问，请咨询运营。` }}
    </p>
    <div class="disable-withdrawal-btn-box">
      <cube-button
        type="button"
        v-if="limitedInfo.limitedType === 1"
        class="disable-btn disable-close-btn"
        @click="closePopup"
      >放弃提现</cube-button>
      <cube-button
        type="button"
        class="disable-btn disable-withdrawal-btn"
        :class="{ 'disable-withdrawal-btn1' : limitedInfo.limitedType !== 1 }"
        @click="goToReturnIntegra"
      >{{ limitedInfo.limitedType === 1 ? '返还积分' : '我知道了'}}</cube-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'disabled-withdrawal-popup',
  props: {
    limitedInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    // 关闭弹窗
    closePopup() {
      this.$emit('close');
    },
    // 跳转负积分返还支付页面
    goToReturnIntegra() {
      if (this.limitedInfo.limitedType !== 1) {
        this.closePopup();
        return;
      }
      let origin = 'http://mykefeng.run4wd.com';
      if (/ssish/.test(location.href) || /yutai365/.test(location.href)) {
        origin = 'https://mykefeng.yutai365.com';
      }
      const userId = this.$route.query.userId;
      window.location.href = `${origin}/mkfv3/returnIntegral?userId=${userId}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.disable-withdrawal-box {
  width: 8.826666667rem;
  background: #ffffff;
  border: 1px solid #eeeeee;
  box-shadow: 0.08rem 0.1333333rem 0.48rem 0.1333333rem
    rgba(161, 168, 194, 0.17);
  border-radius: 0.18666667rem;
  font-family: PingFang SC;
  .disable-withdrawal-title {
    font-size: 0.42666667rem;
    font-weight: bold;
    color: #191919;
    text-align: center;
    margin-top: 0.50666667rem;
  }
  .disable-withdrawal-content {
    width: 7.30666667rem;
    font-size: 0.4rem;
    text-align: left;
    color: #3e3e3e;
    margin: 0.50666667rem auto 0.61333333rem;
  }
  .disable-withdrawal-btn-box {
    text-align: center;
    margin-bottom: 0.58666667rem;
    display: flex;
    .disable-btn {
      display: block;
      width: 3.36rem;
      height: 1.06666667rem;
      font-size: 0.4rem;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #666666;
      border-radius: 0.13333333rem;
      background: #eaeaea;
      margin: auto;
      padding: 0;
    }
    .disable-withdrawal-btn {
      color: #ffffff;
      background: #ff3600;
      &.disable-withdrawal-btn1 {
        width: 280px;
      }
    }
  }
}
</style>